import React from 'react';
import styled from 'styled-components';
import { Col, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '~/hooks/useScreenSizes';
import { useDirection } from '~/hooks/i18nHooks';

function ProductsSummary(props: any) {
  const { payload } = props;
  const { t } = useTranslation('ksaApplication');
  const isMobile = useIsMobile();
  const dir = useDirection();

  const services = payload?.services ?? {};
  const isPOS = !!(services?.POS?.enabled || services?.nGeniusGo?.enabled);
  const isEcommerce = !!(services?.eCommerce?.enabled);

  // Build product label list
  const productLabels: string[] = [];
  if (isEcommerce) productLabels.push(t('E-commerce'));
  if (isPOS) productLabels.push(t('POS'));

  // No of terminals from nGeniusPos or nGeniusGo
  const noOfTerminals: number =
    services?.POS?.terminals ?? services?.nGeniusGo?.terminalFee ?? 1;

  const noOfProducts = productLabels.length;
  const showProductCount = noOfProducts > 1;

  if (!isPOS && !isEcommerce) return null;

  return (
    <div style={{ marginTop: 24 }}>
      <Typography.Title style={{ marginBottom: 15 }} level={4}>
        {t('Products Summary')}
      </Typography.Title>
      <Box dir={dir} isMobile={isMobile}>
        {/* No of Products — only shown when Ecommerce + POS */}
        {showProductCount && (
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Typography.Paragraph className="labelKey">
                {t('No of Products')}
              </Typography.Paragraph>
            </Col>
            <Col span={12}>
              <Typography.Paragraph className="value">{noOfProducts}</Typography.Paragraph>
            </Col>
          </Row>
        )}

        {/* Product */}
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Typography.Paragraph className="labelKey">{t('Product')}</Typography.Paragraph>
          </Col>
          <Col span={12}>
            <Typography.Paragraph className="value">
              {productLabels.join(', ')}
            </Typography.Paragraph>
          </Col>
        </Row>

        {/* No of Terminals — only shown when POS is selected */}
        {isPOS && (
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Typography.Paragraph className="labelKey">
                {t('No of Terminals')}
              </Typography.Paragraph>
            </Col>
            <Col span={12}>
              <Typography.Paragraph className="value">{noOfTerminals}</Typography.Paragraph>
            </Col>
          </Row>
        )}
      </Box>
    </div>
  );
}

const Box = styled.div<any>`
  font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
  background-color: ${({ isMobile }) => (isMobile ? '#ffffff' : '#F9F9F9')};
  padding: 20px 16px;
  border-radius: 8px;
  border: 1px solid #F5F5F5;
  box-shadow: 0 2px 6px 0 rgba(0, 89, 150, 0.03), 0 -1px 8px -10px rgba(0, 89, 150, 0.03);

  .labelKey {
    color: #000;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 14px;
    letter-spacing: 0.14px;
  }

  .value {
    color: #000;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 14px;
    margin-top: 8px;
  }
`;

export default ProductsSummary;
